export const appHead = {"meta":[{"charset":"utf-8"},{"name":"description","content":"Gotong Royong adalah platform kolaborasi sosial yang menghubungkan komunitas untuk saling membantu dan berkolaborasi."},{"name":"keywords","content":"gotong royong, kolaborasi sosial, platform sosial, komunitas indonesia, bantuan sosial"},{"name":"author","content":"Gotong Royong"},{"name":"robots","content":"index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"name":"format-detection","content":"telephone=no"},{"name":"theme-color","content":"#ffffff"},{"property":"og:title","content":"Gotong Royong | Platform Kolaborasi Sosial"},{"property":"og:description","content":"Gotong Royong adalah platform kolaborasi sosial yang menghubungkan komunitas untuk saling membantu dan berkolaborasi."},{"property":"og:image","content":"https://gotongroyong.org/og-image.jpeg"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"property":"og:image:alt","content":"Logo Gotong Royong dengan tagline platform kolaborasi sosial"},{"property":"og:url","content":"https://gotongroyong.org"},{"property":"og:site_name","content":"Gotong Royong"},{"property":"og:locale","content":"id_ID"},{"property":"og:type","content":"website"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"Gotong Royong | Platform Kolaborasi Sosial"},{"name":"twitter:description","content":"Gotong Royong adalah platform kolaborasi sosial yang menghubungkan komunitas untuk saling membantu dan berkolaborasi."},{"name":"twitter:image","content":"https://gotongroyong.org/og-image.jpeg"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"manifest","href":"/site.webmanifest"}],"style":[],"script":[],"noscript":[],"title":"Gotong Royong","titleTemplate":"%s - Platform Kolaborasi Sosial","htmlAttrs":{"lang":"id","style":"scroll-behavior: smooth;"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false